import React, { useState, useRef } from 'react';
import axios from 'axios';
import { Box, Button, Typography, Card, CardContent } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './UploadForm.css';
import API_ENDPOINTS from '../config/apiConfig';

function UploadForm() {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]); // Save the selected file in the state
  };

  const handleDropzoneClick = () => {
    fileInputRef.current.click(); // Trigger hidden input click
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error('Please select a file!', { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 });
      return;
    }

    setUploading(true);

    try {
      const formData = new FormData();
      formData.append('contacts', file);

      const response = await axios.post(API_ENDPOINTS.upload, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.status === 200) {
        toast.success('File uploaded successfully!', { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 });
        setFile(null);
        fileInputRef.current.value = ''; // Clear the file input
      } else {
        toast.error('File upload failed. Please try again.', { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 });
      }
    } catch (error) {
      toast.error('Error occurred during upload.', { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 });
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box className="upload-container">
      <Card className="upload-card">
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Upload Voter Contact CSV File
          </Typography>
          <Box className="dropzone" onClick={handleDropzoneClick}>
            <input
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              ref={fileInputRef}
              className="file-input"
            />
            <CloudUploadIcon style={{ fontSize: 50 }} />
            <Typography variant="body1">
              Drag and drop a CSV file here, or click to select a file
            </Typography>
          </Box>
          {/* Display the selected file name */}
          {file && (
            <Typography variant="body2" style={{ marginTop: '10px' }}>
              Selected File: {file.name}
            </Typography>
          )}
          <Button
            variant="contained"
            color="primary"
            startIcon={<CloudUploadIcon />}
            onClick={handleUpload}
            disabled={uploading}
            style={{ marginTop: '20px' }}
          >
            {uploading ? 'Uploading...' : 'Submit'}
          </Button>
        </CardContent>
      </Card>
      <ToastContainer />
    </Box>
  );
}

export default UploadForm;
